import React, { FC } from 'react';
import { Box, Divider } from '@material-ui/core';
import { Link } from 'react-router-dom';

interface Props {
  label: string;
  link: string;
}

const ResultItem: FC<Props> = ({ label, link }) => {
  if (label.trim().length === 0) {
    return null;
  }

  return (
    <>
      <Box marginY='10px'>
        <Link to={link}>{label}</Link>
      </Box>
      <Divider component='div' />
    </>
  );
};

export default ResultItem;
